import { useState } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel as ReactCarousel } from 'react-responsive-carousel';
import styled, { css } from 'styled-components';
import { isMobile, color } from 'constants/styled-theme';
import { BasicButton } from 'components/common/button';
// eslint-disable-next-line import/no-extraneous-dependencies
import ReactImageMagnify from '@blacklab/react-image-magnify';
import magnifyGrayUrl from 'assets/imgs/magnify-gray.svg';
import magnifyBlueUrl from 'assets/imgs/magnify-blue.svg';
import { MEDIALINK_TYPES } from 'constants/listings';
import videoIcon from 'assets/imgs/play_icon.png';

const StyledReactCarousel = styled(ReactCarousel)`
  &&& .control-arrow {
    margin: 10px;
    height: 35px;
    background-color: ${color('gray80')};
    width: 35px;
    border-radius: 50px;
    display: ${p => (p.showArrows ? 'flex' : 'none')};
    align-items: center;
    top: 40%;
    justify-content: center;
    opacity: 1;
  }
  &&& .slide {
    background: ${color('gray0')};
    justify-content: center;
    align-items: center;
    display: flex;
    div {
      width: 100% !important;
    }
  }

  @media (max-width: ${p => p.theme.mobile}) {
    &&& .carousel {
      height: 270px;
      border: 1px solid #dce3eb;
    }
    &&& .slide {
      div {
        width: 100% !important;
        height: 270px !important;
      }
      height: 270px;
      img {
        width: 100%;
        height: 270px !important;
        object-fit: contain;
      }
    }
  }
`;
const ThumbnailCarousel = styled(ReactCarousel)`
  &&& .carousel-slider {
    display: none;
  }
  &&& .carousel {
    //max-width: 600px;
    //margin-left: 50px;
    width: 100%;
  }
  &&& .thumbs-wrapper {
    margin: 0;
    width: 100%;
    button {
      display: none;
    }
    @media (max-width: ${p => p.theme.mobile}) {
      .thumbs {
        .thumb {
          width: 70px !important;
          min-width: 70px !important;
          height: 52px !important;
        }
      }
    }
    .thumbs {
      width: 100%;
      padding-left: 0;
      display: inline-flex;
      justify-content: ${p => (p.isContentLeft ? 'flex-start' : 'space-between')};
      align-items: center;

      li > img[alt*='video'] {
        &:after {
          display: block;
          position: absolute;
          font-family: 'react-icons' !important;
          content: '\\e925';
          font-size: 60px;
          top: 24px;
          left: 27px;
          height: 52px;
          width: 52px;
          color: #5a5959;
        }
      }
      .thumb {
        cursor: pointer;
        width: 114px;
        min-width: 114px;
        height: 114px;
        border: 1px solid #dce3eb;
        &.selected {
          border: 1px solid #000;
        }
      }
    }
  }
`;
const Magnify = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  margin: 20px 15px;
  cursor: pointer;
  @media (max-width: ${p => p.theme.mobile}) {
    display: none;
  }
`;
const ThumbControl = styled(BasicButton)`
  margin: 10px;
  height: 35px;
  background-color: ${color('gray50')};
  width: 35px;
  border-radius: 50px;
  display: flex;
  opacity: ${p => (p.hideArrow ? 0 : 0.4)};
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 9;
  &::before {
    margin: 0 5px;
    display: inline-block;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    content: '';
    border-left: ${p => (p.isLeft ? 'none' : '8px solid #fff')};
    border-right: ${p => (!p.isLeft ? 'none' : '8px solid #fff')};
  }
  ${p =>
    p.isLeft
      ? css`
          left: -50px;
        `
      : css`
          right: -50px;
        `}
`;
// const ControlContainer = styled.div`
//   position: absolute;
//   top: 27px;
//   display: flex;
//   //max-width: 350px;
//   width: 100%;
//   flex-direction: row;
//   justify-content: space-between;
//   z-index: 9;
//   @media (max-width: ${p => p.theme.mobile}) {
//     display: none;
//   }
// `;

const ThumbContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 25px;
  width: 100%;
  .thumbnail-carousel {
    width: 100%;
  }
`;

const VideoLink = styled(BasicButton)`
  position: relative;
  background: transparent;
  width: 100%;
  height: 100%;
`;

const ImgIcon = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 150px;
  z-index: 99;
`;

const ThumbImg = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: ${p => p.theme.mobile}) {
    ${p =>
      p.isVideo &&
      css`
        &:after {
          font-size: 28px !important;
          top: 11px !important;
          left: 21px !important;
        }
      `};
  }
  ${p =>
    p.isVideo &&
    css`
      width: 100%;
      height: 100%;
      object-fit: contain;
      &:after {
        display: block;
        position: absolute;
        font-family: 'react-icons' !important;
        content: '\\e925';
        font-size: 60px;
        top: 24px;
        left: 27px;
        height: 52px;
        width: 52px;
        color: #5a5959;
      }
    `};
`;

export const useCarousel = (urlImgs, onClick) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const [isMagnified, setIsMagnified] = useState(!isMobile);
  const imgs = urlImgs.map((i, idx) => {
    if (i.type === MEDIALINK_TYPES.Video) {
      return (
        <VideoLink key={i.url} onClick={() => onClick(i.url)}>
          <ImgIcon src={videoIcon} alt={`video${idx}`} />
          <img src={urlImgs[0].url} alt={`item${idx}`} />
        </VideoLink>
      );
    }
    return <img key={i.url} src={i.url} alt={`item${idx}`} />;
  });
  const thumbsImgs = urlImgs.map((i, idx) => {
    if (i.type === MEDIALINK_TYPES.Video) {
      return <img key={`video-${i.url}`} src={urlImgs[0].url} alt={`video`} />;
    }
    return <img key={`video-${i.url}`} src={i.url} alt={`item${idx}`} />;
  });

  const magnifiedImgs = urlImgs.map((i, idx) =>
    i.type === MEDIALINK_TYPES.Video ? (
      <VideoLink key={i.url} onClick={() => onClick(i.url)}>
        <ImgIcon src={videoIcon} alt={`video`} />
        <img src={urlImgs[0].url} alt={`item${idx}`} />
      </VideoLink>
    ) : (
      <ReactImageMagnify
        key={`item${i.url}`}
        imageProps={{
          alt: `item${idx}`,
          // isFluidWidth: true,
          src: i.url
        }}
        magnifiedImageProps={{
          src: i.url,
          width: 1500,
          height: 1500
        }}
        portalProps={{
          placement: 'over'
        }}
      />
    )
  );

  const customRenderThumb = children =>
    children.map(item =>
      item.props.alt === 'video' ? (
        <ThumbImg isVideo key={`video-${item.props.alt}`}>
          <img {...item.props} alt={item.props.alt} />
        </ThumbImg>
      ) : (
        <img key={`thumb-${item.props.alt}`} {...item.props} alt={item.props.alt} />
      )
    );

  return {
    carousel: (
      <StyledReactCarousel
        showArrows={imgs.length > 1}
        infiniteLoop
        showStatus={false}
        showThumbs={false}
        swipeable={isMobile ? !isMagnified : true}
        showIndicators={false}
        transitionTime={600}
        onChange={i => setSlideIndex(i)}
        selectedItem={slideIndex}
      >
        {isMagnified ? magnifiedImgs : imgs}
      </StyledReactCarousel>
    ),
    thumbnails: (
      <ThumbContainer>
        <ThumbControl
          hideArrow={slideIndex === 0}
          isLeft
          onClick={() => setSlideIndex(slideIndex - 1 < 0 ? imgs.length - 1 : slideIndex - 1)}
        />
        <ThumbControl
          hideArrow={slideIndex === imgs.length - 1}
          onClick={() => setSlideIndex(slideIndex + 1 > imgs.length - 1 ? 0 : slideIndex + 1)}
        />
        <ThumbnailCarousel
          showArrows={false}
          showStatus={false}
          showIndicators={false}
          transitionTime={600}
          thumbWidth={114}
          onChange={i => setSlideIndex(i)}
          selectedItem={slideIndex}
          className={'thumbnail-carousel'}
          renderThumbs={customRenderThumb}
          isContentLeft={thumbsImgs.length <= 2}
        >
          {thumbsImgs}
        </ThumbnailCarousel>
      </ThumbContainer>
    ),
    magnifyComponent: (
      <Magnify
        onClick={() => {
          if (urlImgs[slideIndex].type === MEDIALINK_TYPES.Video) {
            onClick(urlImgs[slideIndex].url);
          }
          setIsMagnified(!isMagnified);
        }}
        src={
          isMagnified && urlImgs[slideIndex] && urlImgs[slideIndex].type === MEDIALINK_TYPES.Image
            ? magnifyBlueUrl
            : magnifyGrayUrl
        }
        alt="mag"
      />
    )
  };
};
